//! @ngInject
export function caregiverLookupService($rootScope, $q, DatabaseApi) {
  // Display data should come from the endpoint serving the page. This is the
  // fallback for callers that only have ids, such as a newly received chat.
  const cache = new Map();
  const inFlight = new Map();
  let queued = [];
  let flushScheduled = false;
  const CHUNK_SIZE = 100;

  function searchUrl() {
    return (
      "agencies/" +
      $rootScope.agencyId +
      "/agency_members/" +
      $rootScope.agencyMemberId +
      "/search/caregivers"
    );
  }

  function flush() {
    const requests = queued;
    queued = [];
    flushScheduled = false;
    const groups = new Map();
    for (const request of requests) {
      if (!groups.has(request.url)) groups.set(request.url, []);
      groups.get(request.url).push(request);
    }
    for (const [url, group] of groups) {
      for (let start = 0; start < group.length; start += CHUNK_SIZE) {
        const chunk = group.slice(start, start + CHUNK_SIZE);
        DatabaseApi.get(url + "?ids=" + chunk.map((request) => request.id).join(",") + "&limit=" + chunk.length)
          .then((res) => {
            const items = new Map((res?.data?.items ?? []).map((item) => [String(item.id), item]));
            for (const request of chunk) {
              const item = items.get(request.id) ?? null;
              if (item !== null) cache.set(request.key, item);
              inFlight.delete(request.key);
              request.deferred.resolve(item);
            }
          }, (error) => {
            for (const request of chunk) {
              inFlight.delete(request.key);
              request.deferred.reject(error);
            }
          });
      }
    }
  }

  function byIds(ids) {
    const wanted = [...new Set(ids.filter((id) => id !== null && id !== undefined).map(String))];
    const url = searchUrl();
    return $q.all(wanted.map((id) => {
      // Keep results and in-flight lookups separate across agency/member changes.
      const key = url + ":" + id;
      if (cache.has(key)) return $q.resolve(cache.get(key));
      if (inFlight.has(key)) return inFlight.get(key);
      const deferred = $q.defer();
      inFlight.set(key, deferred.promise);
      queued.push({ id, key, url, deferred });
      if (!flushScheduled) {
        flushScheduled = true;
        // Collect lookups made during the same Angular turn into one request.
        $q.resolve().then(flush);
      }
      return deferred.promise;
    })).then((items) => new Map(
      items.filter((item) => item !== null).map((item) => [String(item.id), item])
    ));
  }

  return {
    byIds,
    byId: function (id) {
      return byIds([id]).then((map) => map.get(String(id)) ?? null);
    }
  };
}
